module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAMAAAC5zwKfAAAAUVBMVEUAAADm5ubo6Ojm5ubn5+ft7e3m5ubm5ubk5OTl5eXm5ubm5ubm5ubl5eXl5eXm5ubm5ubn5+fl5eXl5eXl5eXl5eXl5eXo6Ojo6Oj////m5uZr2l03AAAAGnRSTlMAZiIzVQb3KBwQ/uStgVnZzLyWbUZFOyAWAtiLD+gAAABzSURBVFjD7da5EcMwEENR2PSaknzovth/oaoACUYZ8SpAsn8WZmZmdTpzErSgvkXxTiCiaH5gRm3hBibWl2CHWWWapyDurs2nofuKZgYRvdpDpv0/BBlmddEuJYEaiqJbQER3928zaT3MoA6t2GZmZlaJC+KFNW46/JTAAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu_icon.png
// module id = gI4p
// module chunks = 1